const baseFontWeight = {
  '--fw-400': '400',
  '--fw-500': '500',
  '--fw-600': '600',
  '--fw-700': '700',
  '--fw-900': '900'
}

const baseFontFamily = {
  '--string-font': 'Roboto-Regular',
  '--number-font': 'Inter-Regular'
}

const baseFontSize = {
  '--fs-10': '10px',
  '--fs-12': '12px',
  '--fs-14': '14px',
  '--fs-16': '16px',
  '--fs-20': '20px',
  '--fs-24': '24px',
  '--fs-28': '28px',
  '--fs-32': '32px',
  '--fs-40': '40px',
  '--fs-48': '48px'
}

const baseLineHeight = {
  '--lh-display-58': '58px',
  '--lh-display-48': '48px',
  '--lh-display-40': '40px',
  '--lh-headline-36': '36px',
  '--lh-headline-32': '32px',
  '--lh-headline-28': '28px',
  '--lh-title-28': '28px',
  '--lh-title-24': '24px',
  '--lh-title-20': '20px',
  '--lh-body-24': '24px',
  '--lh-body-20': '20px',
  '--lh-body-18': '18px',
  '--lh-label-18': '18px',
  '--lh-label-16': '16px',
  '--lh-label-14': '14px'
}

const arFontFamily = {
  '--string-font': 'NotoSans-Arabic',
  '--number-font': 'Inter-Regular'
}

const arFontSize = {
  '--fs-10': `${10 + 2}px`,
  '--fs-12': `${12 + 2}px`,
  '--fs-14': `${14 + 2}px`,
  '--fs-16': `${16 + 2}px`,
  '--fs-20': `${20 + 0}px`,
  '--fs-24': `${24 + 0}px`,
  '--fs-28': `${28 + 0}px`,
  '--fs-32': `${32 + 0}px`,
  '--fs-40': `${40 + 0}px`,
  '--fs-48': `${48 + 0}px`
}

const arLineHeight = {
  '--lh-display-58': `${58 + 4}px`,
  '--lh-display-48': `${48 + 4}px`,
  '--lh-display-40': `${40 + 4}px`,
  '--lh-headline-36': `${36 + 4}px`,
  '--lh-headline-32': `${32 + 4}px`,
  '--lh-headline-28': `${28 + 0}px`,
  '--lh-title-28': `${28 + 0}px`,
  '--lh-title-24': `${24 + 2}px`,
  '--lh-title-20': `${20 + 4}px`,
  '--lh-body-24': `${24 + 2}px`,
  '--lh-body-20': `${20 + 4}px`,
  '--lh-body-18': `${18 + 2}px`,
  '--lh-label-18': `${18 + 6}px`,
  '--lh-label-16': `${16 + 4}px`,
  '--lh-label-14': `${14 + 2}px`
}

export const getBaseFeature = () => {
  // 阿语
  if (window.lang === 'ar') {
    return {
      ...baseFontWeight,
      ...arFontFamily,
      ...arFontSize,
      ...arLineHeight
    }
  }
  // 其他
  else {
    return {
      ...baseFontWeight,
      ...baseFontFamily,
      ...baseFontSize,
      ...baseLineHeight
    }
  }
}

export default {
  getBaseFeature
}
